module.exports = __webpack_public_path__ + "static/NYS_DOH_black-d9ae085b8925ba51edeb8a2c3ed8aa8c.jpg";